// extracted by mini-css-extract-plugin
module.exports = {"disabled":"VercelScreen_disabled__Obw6b","container":"VercelScreen_container__oAHlv","subtitle":"VercelScreen_subtitle__Z9M18","footer":"VercelScreen_footer__L1J4a"};